module.exports = __webpack_public_path__ + "static/media/Bilina.40d1a2de.png";